module.exports = __webpack_public_path__ + "static/media/image_7.bcc106ee.png";